// extracted by mini-css-extract-plugin
export default {"favorites":"Favorites_favorites__UgasC"};